import { Injectable } from '@angular/core';
import { BulkOperationNotificationType } from '../enums/bulk-operation-notification-type.enum';
import { BulkOperationFailure } from '../enums/bulk-operation-failure.enum';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { BulkOperationResult } from '../../core/models/bulk-operation-result.model';
import { FailedBulkOperationData } from '../../core/models/failed-bulk-operation-data.model';

@Injectable({
    providedIn: 'root',
})
export class ReplyBulkOperationsNotificationService {
    constructor(
        private notificationsService: NotificationsService,
        private translateService: TranslateService,
    ) {}

    showNotificationForReplies(result: BulkOperationResult, type: BulkOperationNotificationType): void {
        if (!result.areAllChangesSuccessful) {
            this.showNotificationForFailedReplies(result.failures, type);
        } else {
            this.showNotificationForSucceededReplies(result.succeededIds, type);
        }
    }

    private showNotificationForFailedReplies(
        failures: FailedBulkOperationData[],
        type: BulkOperationNotificationType,
    ): void {
        let failureMessage = '<ul>';
        failures.forEach((failure: FailedBulkOperationData) => {
            failureMessage += '<li>';

            switch (failure.reason) {
                case BulkOperationFailure.differentTicketThread: {
                    failureMessage += this.translateService.instant('replies belong to different tickets');
                    break;
                }
                case BulkOperationFailure.repliesAlreadyDeleted: {
                    failureMessage += this.translateService.instant('replies already deleted');
                    break;
                }
                case BulkOperationFailure.unexpectedError:
                default: {
                    failureMessage += this.translateService.instant('unknown error');
                }
            }
            failureMessage += ' (' + failure.ids.length + ')' + '</li>';
        });

        failureMessage += '</ul>';

        let notificationText = this.translateService.instant('Some replies were not') + ' ';
        switch (type) {
            case BulkOperationNotificationType.delete: {
                notificationText += this.translateService.instant('deleted');
                break;
            }
            case BulkOperationNotificationType.hide: {
                notificationText += this.translateService.instant('hidden');
                break;
            }
            case BulkOperationNotificationType.show: {
                notificationText += this.translateService.instant('showed');
                break;
            }
        }

        this.notificationsService.warn(notificationText, failureMessage, {
            timeOut: 0,
        });
    }

    private showNotificationForSucceededReplies(succeededIds: number[], type: BulkOperationNotificationType): void {
        let notificationText = succeededIds.length + ' ' + this.translateService.instant('replies were') + ' ';
        switch (type) {
            case BulkOperationNotificationType.delete: {
                notificationText += this.translateService.instant('deleted');
                break;
            }
            case BulkOperationNotificationType.hide: {
                notificationText += this.translateService.instant('hidden');
                break;
            }
            case BulkOperationNotificationType.show: {
                notificationText += this.translateService.instant('showed');
                break;
            }
        }
        this.notificationsService.success(this.translateService.instant('Success'), notificationText, {
            timeOut: 0,
        });
    }
}
